// 각 운세 유형별 점수에 따른 메시지 배열
const luckMessages = {
  money: {
    low: [
      `오늘은 숨만 쉬어도 손해😰`,
      `지갑 열면 먼지만 날림💨`,
      `카드 긁으면 즉시 파산각💥`,
      `잔고 확인 = 자살행위⚰️`,
      `친구 약속? 무리. 차단각🚫`,
    ],
    medium: [
      `오늘은 별일 없을듯?🤔`,
      `아아 only. 돈낭비 ㄴㄴ☕`,
      `택시는 무슨. 무조건 따릉이🚴`,
      `소비?? 앱테크로 때워라🔥`,
      `1+1 행사가 너의 운명임 ㅇㅇ`,
    ],
    high: [
      `오늘은 뭘 해도 잘되는 날😎`,
      `오늘 로또 안사면 찐따임🎯`,
      `주식 사라. 개이득 확정임💸`,
      `오늘 지름신 강림해도 ㄱㅊ🤑`,
      `부자 느낌 오지게 온다 레츠고💯`,
    ],
  },
  love: {
    low: [
      `넌 걍 짝사랑 머신🤖`,
      `오늘도 씹덕됨ㅋ`,
      `말 걸지 마. 손절각임✂️`,
      `이성운? 그냥 삭제됨🗑️`,
      `존재감 0. 투명인간임👻`,
    ],
    medium: [
      `그럭저럭. 근데 아님 말고~😶`,
      `썸? 걍 친절한 타인임`,
      `기류는 있음. 확신은 없음🤔`,
      `카톡 와도 별 감정 없음`,
      `설렘? 반응 속도 느림ㅋ`,
    ],
    high: [
      `고백해. 오늘은 걍 박아도 됨🔥`,
      `썸 기류 흐름. 진심 있음💓`,
      `플러팅? 걍 들이대. 이건 통함😎`,
      `텐션 불붙음. 분위기 위험해🔥`,
      `분위기 타면 침대까지 직진각😳`,
    ],
  },
  job: {
    low: [
      `출근한 순간 피곤 시작됨.`,
      `오늘 눈치 안 보면 바로 박제다.`,
      `실수 하나면 팀장 눈빛 바뀜👀`,
      `야근 각이다. 약속은 접어둬라.`,
      `말실수 한번으로 해고 가능⚠️`,
    ],
    medium: [
      `무난함. 근데 조용히 가는 게 이득.`,
      `티내지 말고 할 일만 해라.`,
      `오늘은 존재감 OFF가 정답.`,
      `커피 없인 못 버팀. 카페인 필수☕`,
      `팀장 기분 따라 운세가 바뀜ㅋ`,
    ],
    high: [
      `일 터진다. 근데 좋은 쪽임💼`,
      `네 말 한 마디가 회의 뒤집는다⚡`,
      `상사한테 이름 기억받는 날👏`,
      `뭐만 해도 다 술술 풀리는 날😎`,
      `일찍 퇴근 + 칭찬까지? 개이득🍻`,
    ],
  },
};

// 배열에서 랜덤 메시지를 선택하는 함수
const getRandomMessage = (messages: string[]): string => {
  return messages[Math.floor(Math.random() * messages.length)];
};

// 운세 유형과 점수에 따른 메시지를 가져오는 함수
export const getScoreMessage = (type: string, score: number | null) => {
  if (score === null) return "";

  let level: "high" | "medium" | "low";

  if (score <= 30) {
    level = "low";
  } else if (score <= 60) {
    level = "medium";
  } else {
    level = "high";
  }

  // type이 luckMessages에 없는 경우 기본값 설정
  const messageArray =
    luckMessages[type as keyof typeof luckMessages]?.[level] || [];

  // 랜덤 메시지만 반환 (점수 생략)
  return messageArray.length > 0 ? getRandomMessage(messageArray) : "";
};
